// extracted by mini-css-extract-plugin
export default {"bioContainer":"bio_bioContainer__KlaFl","contact":"bio_contact__-i50i"};